<div class="file-container">
    <div class="icon-wrapper pe-1">
        <div *ngIf="(state | async) === 'ready'" class="icon icon-ready"></div>
        <div *ngIf="(state | async) === 'uploading'" class="icon icon-file"></div>
        <div *ngIf="(state | async) === 'canceled'" class="icon icon-file bg-danger"></div>
    </div>
    <div class="file-name-wrapper">
        <p class="label" [ngClass]="{'text-danger': (state | async) === 'canceled'}">{{file.name}}</p>
    </div>
    <ng-container *ngIf="(state | async) === 'ready'">
        <p class="label size-info">{{file.size | fileSize}}</p>
        <button class="btn delete-btn" (click)="delete.emit(file)">
            <div class="icon icon-delete"></div>
        </button>
    </ng-container>
    <ng-container *ngIf="(state | async) === 'uploading'">
        <ngb-progressbar class="upload-progress-bar" [max]="100" [value]="(progress | async)!"/>
        <button class="btn cancel-btn" (click)="cancel.emit(file)">
            <div class="icon icon-cancel"></div>
        </button>
    </ng-container>
</div>
